import { PagedSearch } from '../../../shared/model/index';

/**
 * advanced search params for invoice selector
 */
export class BillingSearch extends PagedSearch {
  // tslint:disable: variable-name
  public BillingIds: number[] = [];
  public ExcludedBillingIds: number[] = [];
  public ProfileIds: number[] = [];
  public RevenueItemNums: number[] = [];
  public AnchorMonth: number;
  public Inactive: boolean;
  public DuesType: boolean;
  public PledgeId: number;
  // tslint:enable: variable-name
}
